import React, { Component } from "react";
import PlatformSidebar from "./PlatformSidebar";
import "./Videos.css";
import VideosHome from "./VideosHome";
import Onboarding from "./Onboarding.js";
import AddFunds from "./AddFunds.js";
import ImportFromPassword from "./ImportFromPassword";
import TransactionStatus from "./TransactionStatus";
import HyperaceConnectWalletModal from "./HyperaceConnectWalletModal";
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import logo from './logo.png';
import Auction from './Auction';
import AuctionCollections from './AuctionCollections';
import {IoMdArrowRoundBack} from "react-icons/io";
import nounsglasses from "./glasses-deep-teal.png";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import { nounsAuctionHouseContractAddress, mainnetNounsAuctionHouseContractAddress } from "./config";

const contract = require("./artifacts/contracts/NounsAuctionHouse.sol/NounsAuctionHouse.json");

let web3;
let usedContractAddress;
if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetNounsAuctionHouseContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = nounsAuctionHouseContractAddress;
}

class ContinuousAuctionCollections extends Component {
  constructor(props) {
    super(props);
    this.selectModal = this.selectModal.bind(this);
    this.setTransactionStatus = this.setTransactionStatus.bind(this);

    this.state = {
      allCollectionDetails: [],
      modalShown: "",
      transactionStatus: "None",
    };
  }

  async componentDidMount() {
    let allCollectionDetails = await encryptUtils.getAllNounsCollectionDetails();
    this.setState({
      allCollectionDetails,
    });

    let self = this;
    const nounsAuctionHouseContract = new web3.eth.Contract(contract.abi, usedContractAddress);
    nounsAuctionHouseContract.events
      .AuctionCreated()
      .on("data", function (event) {
        let data = event.returnValues;
        console.log(data);
        if (self.state.transactionStatus !== "Pending") {
          return;
        }
        self.setState({
          transactionStatus: "Start Auction Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    nounsAuctionHouseContract.events
      .AuctionSettled()
      .on("data", function (event) {
        let data = event.returnValues;
        console.log(data);
        if (
          self.props.account == null ||
          data["sender"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Settle Auction Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    nounsAuctionHouseContract.events
      .AuctionBid()
      .on("data", function (event) {
        let data = event.returnValues;
        console.log(data);
        if (
          self.props.account == null ||
          data["sender"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Create Bid Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });

    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "auction_collections_page",
      "auction_collections_page_load",
      "info",
      "https://the402.xyz",
      {}
    );
  }

  setTransactionStatus(status) {
    this.setState({
      transactionStatus: status,
    });
  }


  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  render() {
    return (
      <div>
        <div>
          <PlatformSidebar
            modalShown={this.state.modalShown}
            selectModal={this.selectModal}
          />
        </div>
        <div className="min-h-screen py-16 bg-custom-white dark:bg-custom-black">
          <div
            onClick={() => {
              window.open(window.location.origin + "/nounsupload", "_self");
            }}
            className="font-nouns md:visible invisible absolute right-12 top-20 cursor-pointer hover:-translate-y-0 hover:scale-105 duration-500 ml-2 w-20 md:w-40 h-14 flex justify-center items-center text-lg font-bold bg-black dark:bg-white rounded-xl dark:text-black text-white">
            <img className="h-8" src={nounsglasses} />
              <div className="mx-2">
              Create
              </div>
          </div>
          {
            this.state.allCollectionDetails.length > 0
              ?
            <div className="w-screen justify-center flex">
              <Auction
                collectionDetails={this.state.allCollectionDetails[0]}
                account={this.props.account}
                setTransactionStatus={this.setTransactionStatus}
                isFromCollections={true}
              />
            </div>
              :
            null
          }
          <div className="mt-8 w-screen border-t-2 dark:border-t-2 dark:border-zinc-800 flex justify-center">
            <div className="w-11/12 justify-center flex">
              <div>
                <div className="font-nouns text-2xl flex w-full justify-center text-gray-500 font-semibold dark:text-zinc-500 mt-8">
                  Collections
                </div>
                <div className="grid grid-cols-1 xl:grid-cols-3 xl:gap-2 lg:grid-cols-3 lg:gap-4">
                  {
                    this.state.allCollectionDetails.map(collectionDetails => {
                      return (
                        <AuctionCollections
                          collectionDetails={collectionDetails}
                          account={this.props.account}
                        />
                      );
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.modalShown === "createAccount" ? (
          <Onboarding selectModal={this.selectModal} />
        ) : this.state.modalShown === "addFunds" ? (
          <AddFunds selectModal={this.selectModal} />
        ) : this.state.modalShown === "importFromPassword" ? (
          <ImportFromPassword selectModal={this.selectModal} />
        ) : null}
        <TransactionStatus
          transactionStatus={this.state.transactionStatus}
          item={this.state.transactedVideo}
        />
      </div>
    );
  }
}

export default ContinuousAuctionCollections;
